import { render, staticRenderFns } from "./VistaNew.vue?vue&type=template&id=4a9549e1&scoped=true"
import script from "./VistaNew.vue?vue&type=script&lang=js"
export * from "./VistaNew.vue?vue&type=script&lang=js"
import style0 from "./VistaNew.vue?vue&type=style&index=0&id=4a9549e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9549e1",
  null
  
)

export default component.exports